module.exports = __webpack_public_path__ + "img/flag-icons.97373fb7.svg";